import { render } from "./CreateLiquidation1.vue?vue&type=template&id=23ef16d0"
import script from "./CreateLiquidation1.vue?vue&type=script&lang=js"
export * from "./CreateLiquidation1.vue?vue&type=script&lang=js"

import "./CreateLiquidation1.vue?vue&type=style&index=0&id=23ef16d0&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__